let storeTransitions = {

  triggerSections: [],

  animate: function () {

    for ( let i = 0; i < this.triggerSections.length; i++) {

      if ( this.triggerSections[i].getBoundingClientRect().top > window.innerHeight / 10 * 3 ) {
        this.triggerSections[i].style.filter = "grayscale(1)";
      } else if ( this.triggerSections[i].getBoundingClientRect().bottom < window.innerHeight / 10 * 3 ) {
        this.triggerSections[i].style.filter = "grayscale(1)";
        this.triggerSections[i].style.transform = "scale(0.95)";
      } else {
        this.triggerSections[i].style.filter = "grayscale(0)";
        this.triggerSections[i].style.transform = "scale(1)";
      }

    }

  }

}

let changeHeaderColors = {

  triggerSections: [],

  change: function () {

    for ( let i = 0; i < this.triggerSections.length; i++ ) {

      if ( this.triggerSections[i].element.getBoundingClientRect().bottom > window.innerHeight / 10 && this.triggerSections[i].element.getBoundingClientRect().top < window.innerHeight / 10 ) {

        if ( this.triggerSections[i].opacity < '0.1' ) {
          document.getElementsByTagName('header')[0].style.pointerEvents = 'none';
        }

        document.getElementsByClassName('store-logo')[0].style.opacity = this.triggerSections[i].opacity;

        document.getElementsByClassName('store-menu')[0].style.opacity = this.triggerSections[i].opacity;

        document.getElementsByClassName('store-menu')[0].style.color = this.triggerSections[i].color;

        let headerSVGs = document.getElementsByTagName('header')[0].getElementsByTagName('svg');

        for ( let j = 0; j < headerSVGs.length; j++ ) {

          let svgElements = headerSVGs[j].getElementsByTagName('*');

          for ( let h = 0; h < svgElements.length; h++) {

            if ( svgElements[h].tagName === 'path' || svgElements[h].tagName === 'rect' || svgElements[h].tagName === 'circle' || svgElements[h].tagName === 'polygon' || svgElements[h].tagName === 'ellipse' || svgElements[h].tagName === 'line' || svgElements[h].tagName === 'polyline' || svgElements[h].text === 'path' ) {

              svgElements[h].style.fill = this.triggerSections[i].color;

            }

          }
          
        }

        break;

      } else {

        document.getElementsByTagName('header')[0].style.pointerEvents = 'unset';
        
        document.getElementsByClassName('store-logo')[0].style.opacity = 'unset';

        document.getElementsByClassName('store-menu')[0].style.opacity = 'unset';

        document.getElementsByClassName('store-menu')[0].style.color = 'unset';

        let svgElements = document.getElementById('store-logo-home').children[0].children;

        for ( let j = 0; j < svgElements.length; j++ ) {

          if ( svgElements[j].tagName === 'path' || svgElements[j].tagName === 'rect' || svgElements[j].tagName === 'circle' || svgElements[j].tagName === 'polygon' || svgElements[j].tagName === 'ellipse' || svgElements[j].tagName === 'line' || svgElements[j].tagName === 'polyline' || svgElements[j].text === 'path' ) {

            svgElements[j].style.fill = 'currentColor';

          }

        }

      }

    }

  }

}

function separateWords (span) {

  let storeFeaturedProductsTitleWords = document.getElementById(span).innerHTML.split(" ");

  document.getElementById(span).innerHTML = "";

  for ( let i = 0; i < storeFeaturedProductsTitleWords.length; i++) {
    document.getElementById(span).innerHTML += '<span>' + storeFeaturedProductsTitleWords[i] + '&nbsp;</span>';
  }

}